import { Sizes } from "../../../constants.js";
export var getAdjustedSize = size => {
  switch (size) {
    case Sizes.SMALL:
      return Sizes.SMALL;
    case Sizes.MEDIUM:
      return Sizes.SMALL;
    default:
      return Sizes.MEDIUM;
  }
};
export var getDescriptionMarginTop = size => {
  switch (size) {
    case Sizes.SMALL:
      return '0';
    case Sizes.MEDIUM:
      return '0';
    default:
      return 'var(--spacing-1)';
  }
};
export var getDynamicListGap = size => {
  switch (size) {
    case Sizes.SMALL:
      return 'var(--spacing-1)';
    case Sizes.MEDIUM:
      return 'var(--spacing-1)';
    default:
      return 'var(--spacing-2)';
  }
};
export var getDynamicListPadding = size => {
  switch (size) {
    case Sizes.SMALL:
      return 'var(--spacing-2) var(--spacing-2)';
    case Sizes.MEDIUM:
      return 'var(--spacing-2) var(--spacing-3)';
    default:
      return 'var(--spacing-3) var(--spacing-4)';
  }
};
export var getFieldSize = size => {
  switch (size) {
    case Sizes.SMALL:
      return Sizes.SMALL;
    case Sizes.MEDIUM:
      return Sizes.SMALL;
    default:
      return Sizes.MEDIUM;
  }
};
export var getFont = size => {
  switch (size) {
    case Sizes.SMALL:
      return 'var(--body-text-x-small)';
    case Sizes.MEDIUM:
      return 'var(--body-text-small)';
    default:
      return 'var(--body-text-medium)';
  }
};

// These margins make the hint icon overall size the same as the buttons that replace it while hovering
export var getHintIconMargin = size => {
  switch (size) {
    case Sizes.SMALL:
      return '5px';
    case Sizes.MEDIUM:
      return '4px';
    default:
      return '9px';
  }
};
export var getHintIconSize = size => {
  switch (size) {
    case Sizes.SMALL:
      return 14;
    case Sizes.MEDIUM:
      return 16;
    default:
      return 18;
  }
};
export var getItemIconSize = size => {
  switch (size) {
    case Sizes.SMALL:
      return 16;
    case Sizes.MEDIUM:
      return 18;
    default:
      return 20;
  }
};
export var getItemPadding = size => {
  switch (size) {
    case Sizes.SMALL:
      return 'calc(var(--spacing-1) / 2)';
    case Sizes.MEDIUM:
      return 'calc(var(--spacing-1) / 2)';
    default:
      return 'calc(var(--spacing-1) / 2)';
  }
};
export var getLineHeight = size => {
  switch (size) {
    case Sizes.SMALL:
      return 'var(--body-text-line-height-x-small)';
    case Sizes.MEDIUM:
      return 'var(--body-text-line-height-small)';
    default:
      return 'var(--body-text-line-height-medium)';
  }
};